import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IListGroupPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const list = createSlice({
    name: 'group/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListGroupPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onAddGroup(state, action) {
            const newData = [...state.data]
            newData.push(action.payload)
            state.data = newData
        },
        onDeleteGroup(state, action) {
            const newData = [...state.data]
            const index = newData.findIndex(item => item._id === action.payload)
            newData.splice(index, 1)
            state.data = newData
        },
        onEditGroup(state, action) {
            const newData = [...state.data]
            const item = newData.find(item => item._id === action.payload._id)
            item.batchName = action.payload.batchName
            state.data = newData
        }
    }
})

export const listActions = list.actions
export default list.reducer
